import { render, staticRenderFns } from "./RecursiveMenu.vue?vue&type=template&id=15a8c7b7&"
import script from "./RecursiveMenu.vue?vue&type=script&lang=js&"
export * from "./RecursiveMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports